/* Bow Buddy Basecamp — small enhancements (reveal-on-scroll, click-to-play video) */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.bb-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initVideo(root) {
    (root || document).querySelectorAll('[data-bb-video]').forEach(function (frame) {
      if (frame.dataset.bbReady) return;
      frame.dataset.bbReady = '1';
      var btn = frame.querySelector('.bb-video__cover');
      var tpl = frame.querySelector('template');
      if (!btn || !tpl) return;
      btn.addEventListener('click', function () {
        frame.appendChild(tpl.content.cloneNode(true));
        btn.remove();
        var v = frame.querySelector('video');
        if (v) { v.play().catch(function () {}); }
      });
    });
  }

  function init(root) { initReveal(root); initVideo(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Cart drawer add-ons: add without leaving the drawer */
(function () {
  document.addEventListener('submit', function (ev) {
    var form = ev.target.closest && ev.target.closest('form[data-bb-upsell]');
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
    ev.preventDefault();
    var btn = form.querySelector('button'); if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (json) {
      if (json.status) { if (btn) { btn.textContent = 'Unavailable'; } return; }
      drawer.renderContents(json);
    }).catch(function () { form.submit(); });
  });
})();
